import { useCallback, useState } from 'react';

import { setUrlParameters } from '../utils';
import { TablePagination } from '../types';

export const usePagination = ({ initial, ignoreQuery }: { initial?: TablePagination, ignoreQuery?: boolean }) => {
  const [_pagination, _setPagination] = useState<TablePagination>(() => {
    if (ignoreQuery) {
      return initial || { page: 1, pageSize: 10 };
    }
    const query = new URLSearchParams(window.location.search);
    const page =  Number(query.get('page')) > 0 ? Number(query.get('page')) : initial?.page || 1;

    return {
      page,
      pageSize: Number(query.get('pageSize')) > 0 ? Number(query.get('pageSize')) : initial?.pageSize || 10,
    };
  });

  const setPagination = useCallback(({ page, pageSize }: TablePagination) => {
    _setPagination({ page, pageSize });
    if (!ignoreQuery) { 
      setUrlParameters({
        page: (page || 1).toString(), 
        pageSize: pageSize.toString(),
      });
    }
  }, [ignoreQuery]);

  return ({
    pagination: _pagination,
    setPagination,
  });
};